var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowPaginationLeft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow-left"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M23.474 16.4635C24.1463 16.4635 24.6912 15.9185 24.6912 15.2463C24.6912 14.5741 24.1463 14.0291 23.474 14.0291V16.4635ZM6.46729 15.2463L5.6066 14.3856C5.13125 14.861 5.13125 15.6316 5.6066 16.107L6.46729 15.2463ZM14.11 24.6104C14.5853 25.0857 15.356 25.0857 15.8314 24.6104C16.3067 24.135 16.3067 23.3643 15.8314 22.889L14.11 24.6104ZM15.8314 7.60361C16.3067 7.12826 16.3067 6.35758 15.8314 5.88223C15.356 5.40689 14.5853 5.40689 14.11 5.88223L15.8314 7.60361ZM23.474 14.0291H6.46729V16.4635H23.474V14.0291ZM15.8314 22.889L7.32797 14.3856L5.6066 16.107L14.11 24.6104L15.8314 22.889ZM7.32797 16.107L15.8314 7.60361L14.11 5.88223L5.6066 14.3856L7.32797 16.107Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowPaginationLeft);
export default __webpack_public_path__ + "static/media/arrow-pagination-left.8dc33ea4b58606c4e9e6cfd264f01491.svg";
export { ForwardRef as ReactComponent };